import { render, staticRenderFns } from "./DoctorApproval.vue?vue&type=template&id=fa223f0c&scoped=true&"
import script from "./DoctorApproval.vue?vue&type=script&lang=js&"
export * from "./DoctorApproval.vue?vue&type=script&lang=js&"
import style0 from "./DoctorApproval.vue?vue&type=style&index=0&id=fa223f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa223f0c",
  null
  
)

export default component.exports